import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledSignalBoxLink = styled.a`
    display: flex;
    align-items: baseline;
    gap: 4px;
    text-decoration: none;
    ${setFontVariant("caption", colorsPalettes.carbon[250])};

    ${SWReactIcons} {
        transform: translate(0, 1px);
        svg {
            fill: ${colorsPalettes.carbon[250]};
        }
    }

    &:hover {
        color: ${colorsPalettes.carbon[400]};
        ${SWReactIcons} {
            svg {
                fill: ${colorsPalettes.carbon[400]};
            }
        }
    }
`;
